import React, { Component } from 'react';
import { io } from 'socket.io-client';
import { UrlConst } from "../../constants";
import { PaymentService } from "../../services";

class PaymentStatus extends Component {
    constructor(props) {
        super(props);
        this.state = { status: 'pending' };
        this.socket = null;
    }

    componentDidMount() {
        this.connect();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.disconnect();
    }

    connect = () => {
        const { reference } = this.props;
        this.socket = io(UrlConst.BASE_URL, {
            transports: ['websocket'],
            withCredentials: true,
        });
        this.socket.emit('payment-updated', reference);
        this.socket.on('payment-completed', this.handlePaymentUpdate);
    };

    disconnect = () => {
        if (this.socket) {
            this.socket.off('payment-completed', this.handlePaymentUpdate);
            this.socket.disconnect();
            this.socket = null;
        }
    };

    handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible' || this.state.status !== 'pending') return;

        // Page became visible again — reconnect the socket in case it was killed
        this.disconnect();
        this.connect();

        // HTTP fallback: the payment may have completed while the socket was dead
        const { reference } = this.props;
        PaymentService.checkPaymentStatus(reference)
            .then(res => {
                if (res?.data?.status && res.data.status !== 'pending') {
                    this.handlePaymentUpdate({ reference, status: res.data.status });
                }
            })
            .catch(() => {});
    };

    handlePaymentUpdate = (data) => {
        const { reference } = this.props;
        if (data.reference === reference) {
            this.setState({ status: data.status });
            setTimeout(() => {
                if (window.opener) window.close();
                else alert('Payment received. Please close this tab manually.');
            }, 3000);
        }
    };

    render() {
        const { status } = this.state;
        return (
            <span>
                {status === 'pending' && (
                    <span className="ps-status-pending">
                        <span>Waiting for payment...</span>
                        <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14 }} />
                    </span>
                )}
                {status === 'successful' && <span className="ps-status-success">✅ Payment successful</span>}
                {status !== 'pending' && status !== 'successful' && (
                    <span className="ps-status-failed">❌ Payment {status}</span>
                )}
            </span>
        );
    }
}

export default PaymentStatus;
